import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ChevronDownIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M11.6012 5.60272C11.7957 5.40897 12.1109 5.40897 12.3054 5.60272C12.5 5.79646 12.5 6.11052 12.3054 6.30427L8.32101 10.2733C8.12651 10.467 7.81124 10.467 7.61673 10.2733L3.6323 6.30427C3.43779 6.11052 3.43779 5.79646 3.6323 5.60272C3.8268 5.40897 4.14207 5.40897 4.33658 5.60272L7.96887 9.22093L11.6012 5.60272Z"
      fill="currentColor"
    />
  </svg>
);
